
export default {
  methods: {
    getRandomColor() {
      const otherColors = [
        "#FF0000", // red
        "#4E5FF1", // cyan
        "#49DD9F", // green
        "#A020F0", // purple
        "#3F51B5", // dark blue
        "#F9C80E", // yellow
        "#F86624", // orange
        "#F9A3A4", // pink
        "#8D5B4C", // brown
        "#A5978B", // gray
      ];

      return otherColors[Math.floor(Math.random() * otherColors.length)];
    },

    getFundHexColor(fundRun) {
      const fundColorList = {
        9118: "#4E5FF1", // multiaxis
        9725: "#FF0079", // silicon
        9362: "#00AA9D", // compass acciones chilenas
        9937: "#832FED", // medtech
        9958: "#135D75", // deuda usa
        10275: "#CA9328", // compass equilibrio
        10348: "#1EC26A", // e-fund
        10431: "#C50076", // compass liquidez
        total: "steelblue",
        others: "grey",
      };
      return fundColorList[fundRun] || this.getRandomColor();
    },
  },
};
